import { Image } from "@chakra-ui/react";
import { ReactElement } from "react";
import { AiOutlineSwap } from "react-icons/ai";
import { FiGrid } from "react-icons/fi";
import { PiGraduationCapBold } from "react-icons/pi";
import { RiHomeLine } from "react-icons/ri";
import { TbBuildingBridge2 } from "react-icons/tb";

import {
  AppRoute,
  isPPDeprecated,
  MYSTIC_URL,
  PUSD_URL,
  ROYCO_DOMAIN_URL,
  STAKING_URL,
  SWAP_URL,
} from "@/constants/shared";
import { useAuth } from "@/hooks/useAuth";
import { useDailySpinOnchain } from "@/hooks/useDailySpinOnchain";
import { isTruthy } from "@/utils";

export type PageNavItem = {
  name: string;
  icon: ReactElement;
  to: string;
  showExternalIcon?: boolean;
  shouldShowNotification?: boolean;
  hidden?: boolean;
};

export type PageNavSection = {
  name: string;
};

export const useNavbarPages = () => {
  const { isAuthenticated } = useAuth();
  const { hasSpunToday } = useDailySpinOnchain();
  // const { currentUserData } = useCurrentUserData();
  // const shouldShowSeasonClaimPages = Boolean(currentUserData?.seasonOneAllocation?.calculatedTotal);
  // const shouldShowInitialClaimNotification =
  //   // if they have an any total allo they will have some initial, and if they havent claimed it yet
  //   (Boolean(currentUserData?.seasonOneAllocation?.calculatedTotal) &&
  //     !currentUserData?.seasonOneAllocation?.airdropClaim?.initialClaimTimestamp) ||
  //   // OR if they won a battle group and haven't claimed it yet
  //   (Boolean(currentUserData?.seasonOneAllocation?.battleGroupWonAt) &&
  //     !currentUserData?.seasonOneAllocation?.airdropClaim?.mainnetClaimTimestamp);

  const PUBLIC_PAGES: PageNavItem[] = [
    { name: "Home", icon: <RiHomeLine />, to: AppRoute.Home },
    {
      name: "Bridge",
      icon: <TbBuildingBridge2 />,
      to: AppRoute.BridgeWithDefaults,
    },
    {
      name: "Swap",
      icon: <AiOutlineSwap />,
      to: SWAP_URL,
      showExternalIcon: true,
    },
    {
      name: "Stake",
      icon: <Image src="/assets/home/plume-feather-gray.svg" />,
      to: STAKING_URL,
      showExternalIcon: true,
    },
    !isPPDeprecated
      ? { name: "Level Up", icon: <PiGraduationCapBold />, to: AppRoute.Quests }
      : null,
    { name: "Discover", icon: <FiGrid />, to: AppRoute.Apps },
  ].filter(isTruthy);

  const ADMIN_PAGES: PageNavItem[] = [];

  const PRIVATE_PAGES: PageNavItem[] = [
    {
      name: "Mint pUSD",
      to: PUSD_URL,
      showExternalIcon: true,
      icon: <Image src="/assets/home/icons/pusd.svg" />,
    },
    {
      name: "Daily Spin",
      to: AppRoute.DailySpin,
      shouldShowNotification: !hasSpunToday && isAuthenticated,
      icon: <Image src="/assets/home/icons/daily-spin.svg" />,
    },
    {
      name: "Royco",
      icon: <Image src="/assets/home/icons/royco.svg" />,
      to: ROYCO_DOMAIN_URL,
      showExternalIcon: true,
    },
    isAuthenticated
      ? {
          name: "Profile",
          to: AppRoute.MyProfile,
          icon: <Image src="/assets/home/icons/profile.svg" />,
        }
      : null,
    {
      name: "Lend & Borrow",
      icon: <Image src="/assets/home/icons/mystic.svg" />,
      to: MYSTIC_URL,
      showExternalIcon: true,
    },
    !isPPDeprecated
      ? {
          name: "Leaderboard",
          icon: <Image src="/assets/home/icons/leaderboard.svg" />,
          to: AppRoute.Leaderboard,
        }
      : null,
    // shouldShowSeasonClaimPages
    //   ? {
    //       name: "Airdrop",
    //       to: AppRoute.SeasonOneClaim,
    //       shouldShowNotification: shouldShowInitialClaimNotification,
    //     }
    //   : null,
    !isPPDeprecated
      ? {
          name: "Guardians of Plume",
          to: AppRoute.GuardiansOfPlume,
          icon: <Image src="/assets/home/icons/guardians.svg" />,
        }
      : null,
  ].filter(isTruthy);

  const FAVORITE_PAGES: PageNavItem[] = [];

  const MORE_PAGES: PageNavItem[] = PRIVATE_PAGES;
  return {
    PUBLIC_PAGES,
    ADMIN_PAGES,
    PRIVATE_PAGES,
    FAVORITE_PAGES,
    MORE_PAGES,
  };
};
